import React, { FunctionComponent, useState } from 'react';
import { ISourceDataStore } from '@stores/sourceDataStore';
import SourceFactory from '@components/sources/sourceFactory';
import { SourceConfig } from '@stores/source';

interface OwnProps {
  source: ISourceDataStore;
  onChange: (config: SourceConfig) => void;
}

type Props = OwnProps;

const ResourcesEdit: FunctionComponent<Props> = (props: Props) => {
  const { source, onChange } = props;
  const [show, setShow] = useState(true);
  const resourcesComponent = SourceFactory(source.sourceDef.category).getResourcesComponent({
    onChange,
    onSingleResourceOrLess: () => setShow(false),
    source,
  });
  return !show ? <div>'No Resources'</div> : resourcesComponent;
};

export default ResourcesEdit;
